import React from 'react';
import { OutboundLink } from 'gatsby-plugin-google-analytics';
import { withPrefix, Link } from 'gatsby';
import Icon from '@mdi/react'
import { mdiFacebook, mdiInstagram, mdiTwitter, mdiLinkedin, mdiXing, mdiYoutube } from '@mdi/js';
import Consent from "../components/Consent"

const Footer = (locale) => {
  return (

    <footer>

      <Consent locale={locale.locale}/>

      <div className="container footer-upper">
        <div className="columns is-flex-mobile">
          <div className="column is-one-third is-flex-mobile">
            <div className="content-box" itemScope itemType="http://schema.org/Organization" >
              <strong className="is-hidden-mobile">{ locale.locale === "en" ? 'Contact' : 'Kontakt'} - <span itemProp="name"> presono GmbH </span></strong>
              <ul itemProp="address" itemScope itemType="http://schema.org/PostalAddress">
                <li itemProp="email">info@presono.com</li>
                <li itemProp="telephone" >+43 650 - 980 80 35</li>
                <li itemProp="streetAddress">Landstrasse 15</li>
                <li itemProp="postalCode">A-4020 Linz</li>
              </ul>
            </div>
            <div className="logo-box">
              <div className="columns is-flex-mobile">
                <div className="column is-6 is-flex-mobile">
                  <figure className="image is-4by3">
                    <img src={withPrefix('/img/tech2b.svg')} alt="Logo" />
                  </figure>
                </div>
                <div className="column is-6 is-flex-mobile">
                  <figure className="image is-4by3">
                    <img src={withPrefix('/img/ffg.svg')} alt="Logo" />
                  </figure>
                </div>
              </div>
            </div>
          </div>
          <div className="column is-two-thirds is-flex-mobile">
            <div className="columns footer-links">
              <div className="column is-3 is-hidden-mobile">
                <strong>presono.com</strong>
                <ul>
                  <li><Link to={ locale.locale === "en" ? "/features" : "/de/features" }>Features</Link></li>
                  <li><Link to={ locale.locale === "en" ? "/solutions" : "/de/solutions" }>{ locale.locale === "en" ? 'Solutions' : 'Lösungen'}</Link></li>
                  <li><Link to={ locale.locale === "en" ? "/pricing" : "/de/pricing" }>{ locale.locale === "en" ? 'Pricing' : 'Preise'}</Link></li>
                  <li><Link to={ locale.locale === "en" ? "/apps" : "/de/apps" }>Apps</Link></li>
                  <li><Link to={ locale.locale === "en" ? "/blog" : "/de/blog" }>Blog</Link></li>
                  <li><Link to={ locale.locale === "en" ? "/contact" : "/de/contact" }>{ locale.locale === "en" ? 'Contact' : 'Kontakt'}</Link></li>
                </ul>
              </div>
              <div className="column is-3 is-hidden-mobile">
                <strong>Solutions</strong>
                <ul>
                  <li><Link to={ locale.locale === "en" ? "/solutions/en/company" : "/solutions/de/company" }>{ locale.locale === "en" ? "in your Company" : "im Unternehmen" }</Link></li>
                  <li><Link to={ locale.locale === "en" ? "/solutions/en/products" : "/solutions/de/products" }>{ locale.locale === "en" ? "your Products" : "von Produkten" }</Link></li>
                  <li><Link to={ locale.locale === "en" ? "/solutions/en/sales" : "/solutions/de/sales" }>{ locale.locale === "en" ? "in Sales" : "im Vertrieb" }</Link></li>
                  <li><Link to={ locale.locale === "en" ? "/solutions/en/fairs" : "/solutions/de/fairs" }>{ locale.locale === "en" ? "at Fairs" : "auf Messen" }</Link></li>
                  <li><Link to={ locale.locale === "en" ? "/solutions/en/seminars" : "/solutions/de/seminars" }>{ locale.locale === "en" ? "at Seminars" : "in Seminaren & Schulungen" }</Link></li>
                  <li><Link to={ locale.locale === "en" ? "/solutions/en/stores" : "/solutions/de/stores" }>{ locale.locale === "en" ? "in Stores" : "im Store" }</Link></li>
                </ul>
              </div>
              <div className="column is-3 is-flex-mobile">
                <strong className="is-hidden-mobile">Info</strong>
                <ul>
                  {/*<li><a href="#">Jobs</a></li>*/}
                  <li><Link to={ locale.locale === "en" ? "/about" : "/de/about" }>About</Link></li>
                  <li><Link to={ locale.locale === "en" ? "/press" : "/de/press" }>{ locale.locale === "en" ? "Press" : "Presse" }</Link></li>
                  <li><OutboundLink target="_blank" href="https://help.presono.com">Help</OutboundLink></li>
                  { locale.locale === "de" ? <li> <Link to="/de/kennenlernen"> Kennenlernen </Link> </li> : ""}
                  { locale.locale === "de" ? <li> <Link to="/de/messe"> Messe </Link> </li> : ""}
                  {/*<li><a href="#">Partner</a></li>*/}
                </ul>
              </div>
              <div className="column is-3 is-flex-mobile">
                <strong className="is-hidden-mobile">Ressources</strong>
                <ul>
                  <li><Link to={ locale.locale === "en" ? "/impressum" : "/de/impressum" }>{ locale.locale === "en" ? "Imprint" : "Impressum" }</Link></li>
                  <li><Link to={ locale.locale === "en" ? "/datenschutz" : "/de/datenschutz" }>{ locale.locale === "en" ? "Privacy policy" : "Datenschutzrichtlinie" }</Link></li>
                  <li><Link to={ locale.locale === "en" ? "/agb" : "/de/agb" }>{ locale.locale === "en" ? "Terms" : "AGB" }</Link></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container footer-lower">
        <div className="columns">
          <div className="column is-half">
            <p>©2020 - presono GmbH . All rights reserved.</p>
          </div>
          <div className="column is-half">
            <div className="social">
              <a rel="noopener noreferrer" target="_blank" href="https://www.facebook.com/presono">
                <Icon path={mdiFacebook}
                  size={1}
                  color="#95B0BE"
                  />
              </a>
              <a rel="noopener noreferrer" target="_blank" href="https://www.instagram.com/_presono">
                <Icon path={mdiInstagram}
                  size={1}
                  color="#95B0BE"
                  />
              </a>
              <a rel="noopener noreferrer" target="_blank" href="https://twitter.com/presono_startup">
                <Icon path={mdiTwitter}
                  size={1}
                  color="#95B0BE"
                  />
              </a>
              <a rel="noopener noreferrer" target="_blank" href="https://www.linkedin.com/company/presono/">
                <Icon path={mdiLinkedin}
                  size={1}
                  color="#95B0BE"
                  />
              </a>
              <a rel="noopener noreferrer" target="_blank" href="https://www.xing.com/companies/presonosmartinformationgmbh">
                <Icon path={mdiXing}
                  size={1}
                  color="#95B0BE"
                  />
              </a>
              <a rel="noopener noreferrer" target="_blank" href="https://www.youtube.com/channel/UCjJoIsOqQIfN-GMhG-YUbVQ">
                <Icon path={mdiYoutube}
                  size={1}
                  color="#95B0BE"
                  />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
